/* unplugin-vue-components disabled */import { render } from "./PublicationTable.vue?vue&type=template&id=21bfb849&ts=true"
import script from "./PublicationTable.vue?vue&type=script&lang=ts"
export * from "./PublicationTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__